/* eslint-disable no-console */

import { register } from "register-service-worker";
import { isNativeMobileApp } from "@/mobile/runtime";

async function removeStaleWebCaches() {
  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
  } catch (error) {
    console.warn("Unable to remove an earlier service worker:", error);
  }

  try {
    if ("caches" in window) {
      const cacheNames = await window.caches.keys();
      await Promise.all(cacheNames.map((cacheName) => window.caches.delete(cacheName)));
    }
  } catch (error) {
    console.warn("Unable to clear an earlier web cache:", error);
  }
}

export async function prepareWebRuntime() {
  const isEmbeddedPortal = window.self !== window.top;
  if (isNativeMobileApp || isEmbeddedPortal) {
    // Packaged shells are already an offline copy, while embedded live-portal
    // pages must always use the current deployment. Neither should retain a PWA
    // worker or Cache Storage from an earlier web build.
    await removeStaleWebCaches();
    return;
  }

  if (process.env.NODE_ENV !== "production") return;
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n"
        + "For more details, visit https://goo.gl/AFskqB",
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
